import { HubConnectionBuilder, LogLevel, HubConnection } from '@microsoft/signalr'

class SignalRController {
    rConnection: HubConnection;
    constructor() {
        this.rConnection = new HubConnectionBuilder().withUrl("/signalr").withAutomaticReconnect().configureLogging(LogLevel.Information).build();
        this.rConnection.start().catch(error => console.log(error));
    }

    registerReceiveEvent = (methodName, callback) => {
        this.rConnection.on(methodName, function (message) {
            console.log(message);
            callback(JSON.parse(message));
        });
    }

    unRegisterReceiveEvent = (methodName) => {
        this.rConnection.off(methodName);
    }

    sendMessage = (message) => {
        return this.rConnection.invoke("SendMessage", message).catch(function (data) { alert("cannot connect to the server!") });
    }
}

const SignalRService = new SignalRController();
export default SignalRService;